import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, IndexLink, withRouter } from 'react-router';
import CaretIcon from 'modules/Common/components/svg/CaretIcon';
import {activeClassName} from 'utils/routeUtils';
import {titleToId} from 'utils/url-rewrite';

function navLiWithLink(router, link, linkLocation) {
  const actualClass = {};

  const showOnDesktop = link.inDesktopDropdown ? linkLocation == "more-menu" : linkLocation == "secondary-nav";
  const showOnTablet = (link.inDesktopDropdown || link.inDropdown) ? linkLocation == "more-menu" : linkLocation == "secondary-nav";
  actualClass.className = '';
  if (!showOnTablet) {
    actualClass.className = 'hide-on-tablet';
  }


  if (!showOnDesktop) {
    actualClass.className = actualClass.className + ' hide-on-desktop';
  }

  return (
    <li key={link.href} {...actualClass}>
      {link.href.includes('://')
       ? <a href={link.href} target="_blank">{link.text}</a>
       : <Link className={activeClassName(router, link, "nav-active")} id={"nav-level2-"+titleToId(link.text)} to={link.href}>{link.text}</Link>}

    </li>
  );
}

@withRouter
export default class SecondaryNav extends Component {
  static propTypes = {
    router: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    opener: PropTypes.func.isRequired,
    moreOpen: PropTypes.bool,
    moreOpener: PropTypes.func,
    title: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(PropTypes.shape({
        href: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        isIndex: PropTypes.bool
      })).isRequired,
    back: PropTypes.arrayOf(PropTypes.shape({
        href: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
      }))
  };

  moreLinksMenu(links, moreOpen, moreOpener) {
    const moreLinksTablet = links.filter(link => link.inDropdown || link.inDesktopDropdown);
    const moreLinksDesktop = links.filter(link => link.inDesktopDropdown);

    let className = 'nav-level2-more no-link';

    if (moreOpen) {
      className += ' nav-level2-more-open';
    }

    if (!moreLinksTablet.length) {
      className += ' hide-on-tablet';
    }

    if (!moreLinksDesktop.length) {
      className += ' hide-on-desktop';
    }

    return <li className={className} onClick={e => moreOpener(e)}>
      More <CaretIcon type="line" direction={ moreOpen ? "up" : "down" }/>
      <ul className={!moreOpen && "nav-level2-more-closed"}>
        { links.map(link => navLiWithLink(this.props.router, link, "more-menu")) }
      </ul>
    </li>;
  }

  render () {
    const {open, opener, moreOpen = false, moreOpener = () => {}, title, links, back = []} = this.props;
    const topLevelClassList = ["nav-level2"];

    if (links.length == 1) {
      topLevelClassList.push("nav-level2-solo");
    }
    return (
      <div className={topLevelClassList.join(" ")}>
        <div className="nav-level2-label" onClick={e => opener(e)}>
          <h1 className="nav-level2-label-text">{title}</h1>
          <span className="nav-level2-label-caret"><CaretIcon type="line" direction={open?"up":"down"}/></span>
        </div>
        <div className={`nav-level2-menu${open?" open":""}`} onClick={e => {
          opener(e, false);
          moreOpener(e,false);
        }}>
          <ul>
            { links.map(link => navLiWithLink(this.props.router, link, "secondary-nav")) }
            { links.length > 0 && this.moreLinksMenu(links, moreOpen, moreOpener) }
          </ul>
          <ul className="nav-level2-return">
            {
              back.map(link => (
                <li key={link.href}><IndexLink activeClassName="nav-active" to={link.href}>{link.text}</IndexLink></li>
              ))
            }
            <li><IndexLink to="/">Sporting Life Home</IndexLink></li>
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Common/containers/SecondaryNav.js